

































import { Component,Prop, Vue } from 'vue-property-decorator';

@Component
export default class FlexToolbar extends Vue {
  toolbarColor :String = 'brown';

}
